export const PARTICIPANT_LIST_COLUMNS = 3;
export const PARTICIPANT_LIST_ROWS = 6;
export const PARTICIPANT_LIST_ITEMS_PER_PAGE = PARTICIPANT_LIST_COLUMNS * PARTICIPANT_LIST_ROWS;
